/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import Swiper, { Pagination } from 'swiper';
import { cdnUrlConfig } from '../Utils/atoms';

const bullet = [
	'펫룸홈',
	'펫룸콘텐츠',
	'충전소',
	'댕냥별',
	'테마월드',
	'게임랜드',
	'인테리어샵',
	'펫스타그램',
	'펫라이프',
	'펫다이어리',
	'펫팔',
	'펫시설찾기',
	'마이페이지',
];

const Tutorial = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	useEffect(() => {
		Swiper.use([Pagination]);
		new Swiper('.main', {
			slidesPerView: 1,
			spaceBetween: 30,
			autoHeight: 'auto',
			slideToClickedSlide: true,
			on: {
				slideNextTransitionStart: function () {
					const scX = document.querySelector('.swiper-pagination');
					const sBullet = document.querySelector(
						'.swiper-pagination-bullet-active'
					);
					for (let i = 4; i <= scX.children.length; i++) {
						if (this.realIndex === i)
							scX.scrollLeft += sBullet.offsetWidth * 1.8;
					}
				},
				slidePrevTransitionStart: function () {
					const scX = document.querySelector('.swiper-pagination');
					const sBullet = document.querySelector(
						'.swiper-pagination-bullet-active'
					);
					for (let j = 9; j >= 0; j--) {
						if (this.realIndex === j)
							scX.scrollLeft -= sBullet.offsetWidth * 1.5;
					}
				},
				activeIndexChange: function () {
					if (0 <= window.scrollY) window.scrollTo(0, 0);
				},
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: function (idx, className) {
					return '<div class="' + className + '">' + bullet[idx] + '</div>';
				},
			},
		});
	}, []);

	// 이미지 슬라이드 생성
	const SwiperSlideBox = ({ name, num }) => {
		const images = [...Array(num)].map(
			(_, i) => `${IMG_URL}/images/tutorial/guide_${name}${i + 1}.png`
		);

		return (
			<article className='swiper-slide'>
				{images.map((image, index) => (
					<div key={index}>
						<img src={image} alt={`가이드 이미지${index + 1}`} />
					</div>
				))}
			</article>
		);
	};

    return (
        <div id="wrap">
            <div className="container">
                <div className="content tutorial">
                    <main className="main swiper-container">
                        <section className="swiper-wrapper">
                            <SwiperSlideBox name={'pethome'} num={15}/> {/** 펫룸홈 */}
                            <SwiperSlideBox name={'petroomcontents'} num={12}/> {/** 펫룸콘텐츠 */}
                            <SwiperSlideBox name={'charge'} num={3}/> {/** 충전소 */}
                            <SwiperSlideBox name={'star'} num={5}/> {/** 댕냥별 */}
                            <SwiperSlideBox name={'word'} num={3}/> {/** 테마월드 */}
                            <SwiperSlideBox name={'gameland'} num={3}/> {/** 게임랜드 */}
                            <SwiperSlideBox name={'shop'} num={5}/> {/** 인테리어샵 */}
                            <SwiperSlideBox name={'petstagram'} num={2}/> {/** 펫스타그램 */}
                            <SwiperSlideBox name={'petlife'} num={2}/> {/** 펫라이프 */}
                            <SwiperSlideBox name={'petdiary'} num={3}/> {/** 펫다이어리 */}
                            <SwiperSlideBox name={'petpal'} num={2}/> {/** 펫팔 */}
                            <SwiperSlideBox name={'search'} num={2}/> {/** 펫시설찾기 */}
                            <SwiperSlideBox name={'my'} num={4}/> {/** 마이페이지 */}
                        </section>
                        <div className="swiper-pagination"></div>
                    </main>
                </div>
            </div>
        </div>
    );
}

export default Tutorial;
